import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hostkeycom.webp';
import screenshot_target from '../../../images/letterfunnel/peterchaianov.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter Chaianov"
      firstname="Peter"
      companyname="Hostkey.com"
      competition="Hetzner en Leaseweb"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/peterchaianov.js